import React, { useState, useRef } from "react";

import "./promosAll.css";

import PromopostEditor from "../_PromopostEditor/PromopostEditor";
import PromopostComponent from "../_PromopostComponent/PromopostComponent";

const PromosAll = ({
  promos,
  isPromosLoading,
  menus,
  isAllMenusLoading,
  handleCreatePromopost,
  handleTogglePromopostActive,
  handleUpdatePromopost,
  handleDeletePromopost,
  mediaURLs,
  setMediaURLs
}) => {
  const [promosCopies, setPromosCopies] = useState([]);
  const [nameFilter, setNameFilter] = useState("");

  let postsCopiesRef = useRef(null);

  const handleCopyPromopost = (promopost) => {
    setPromosCopies((promosCopies) => [...promosCopies, promopost]);

    setTimeout(() => {
      postsCopiesRef.current.scrollIntoView(true);
    }, 500);
  };

  const handleRemoveFromCopy = (copyID) => {
    setPromosCopies((promosCopies) =>
      promosCopies.filter((promopost) => promopost._id !== copyID)
    );
  };

  return (
    <div className="subSection promosActiveSubsection">
      <h3>ALL POSTS</h3>
      <div className="promosActiveSubsection">
        <input
          type="text"
          name="nameFilter"
          id="nameFilter"
          placeholder="Enter post name..."
          value={nameFilter}
          onChange={(e) => setNameFilter(e.target.value)}
        />
      </div>
      {promos.length && !isPromosLoading ? (
        promos.map((promopost) => (
          <PromopostComponent
            styleProp={
              nameFilter &&
              !promopost.promopostName
                .toLowerCase()
                .includes(nameFilter.toLowerCase())
                ? "hidden"
                : "visible"
            }
            key={promopost._id}
            promopost={promopost}
            staticMenus={menus}
            handleTogglePromopostActive={handleTogglePromopostActive}
            handleUpdatePromopost={handleUpdatePromopost}
            handleCopyPromopost={handleCopyPromopost}
            isCopied={
              promosCopies.length && promosCopies.length > 0 ? true : false
            }
            handleDeletePromopost={handleDeletePromopost}
            mediaURLs={mediaURLs}
            setMediaURLs={setMediaURLs}
          />
        ))
      ) : isPromosLoading ? (
        <div className="promosActiveSubsection__loadingMessage">Loading...</div>
      ) : (
        <div className="promosActiveSubsection__emptyMessage">
          No posts in the database
        </div>
      )}
      <div
        id="promosActiveSubsection__copiesContainer"
        className="promosActiveSubsection__copiesContainer"
        ref={postsCopiesRef}
        style={{ scrollMargin: "3em" }}
      >
        {promosCopies.length ? <h3>Copy</h3> : null}
        {promosCopies.length
          ? promosCopies.map((promoCopy) => {
              let cleanCopy = Object.keys(promoCopy).reduce((object, key) => {
                if (
                  key !== "pictureFolder" &&
                  key !== "picturesURLs" &&
                  key !== "_id"
                ) {
                  object[key] = promoCopy[key];
                }
                return object;
              }, {});

              cleanCopy.active = false;
              cleanCopy.promopostDate = new Date(Date.now()).toISOString();

              return (
                <React.Fragment key={promoCopy._id}>
                  <PromopostEditor
                    key={promoCopy._id}
                    promopost={cleanCopy}
                    staticMenus={menus}
                    isFromCopy={true}
                    handleSavePromopost={handleCreatePromopost}
                    handleCancel={() => handleRemoveFromCopy(promoCopy._id)}
                    mediaURLs={mediaURLs}
                    setMediaURLs={setMediaURLs}
                  />
                </React.Fragment>
              );
            })
          : null}
      </div>
    </div>
  );
};

export default PromosAll;
